import { statItems } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      {/* 左侧大主视觉底图 */}
      <div className="absolute inset-y-0 left-0 w-full lg:w-3/5">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20and%20vibrant%20flat%20illustration%20of%20a%20cozy%20island%20of%20gifts%20and%20daily%20digital%20goodies%2C%20soft%20coral%20peach%20and%20cream%20palette%2C%20floating%20cards%20and%20folders%2C%20cheerful%20community%20feel%2C%20clean%20modern%2C%20high%20detail&width=1600&height=1000&seq=fuli-hero&orientation=landscape"
          alt="福利岛每日上新资源与最新合集"
          className="h-full w-full object-cover opacity-95"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background-100/40" />
      </div>

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-2 lg:py-24">
        {/* 文案侧 */}
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/80 px-3 py-1 text-xs font-medium text-primary-600">
            <i className="ri-calendar-check-line" aria-hidden="true" />
            每日更新 · 今日资源持续上新中
          </span>
          <h1 className="mt-5 text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            福利岛今日更新
            <br />
            新内容速递一眼看全
          </h1>
          <p className="mt-4 text-base leading-relaxed text-foreground-600 md:text-lg">
            这里把每日上新资源与最新合集集中放好。想看今天有什么新东西，直接进速递流；想系统找系列内容，去翻热门板块与最新合集，追更找新料都不迷路。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#feed"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
            >
              <i className="ri-flashlight-fill" aria-hidden="true" />
              看今日新内容速递
            </a>
            <a
              href="#collection"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors"
            >
              <i className="ri-folders-line" aria-hidden="true" />
              逛最新合集
            </a>
          </div>
        </div>

        {/* 视觉侧：大小卡叠排 */}
        <div className="relative hidden md:block">
          <div className="absolute right-0 top-2 w-full max-w-md space-y-4">
            <div className="ml-auto w-4/5 rounded-xl bg-background-50/95 p-5 shadow-sm ring-1 ring-background-200 animate-float-in" style={{ animationDelay: "0.05s" }}>
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-primary-600">今日速递 · 刚刚</span>
                <span className="flex items-center gap-1 text-xs text-accent-600"><i className="ri-fire-line" aria-hidden="true" />热度</span>
              </div>
              <p className="mt-2 text-sm font-semibold text-foreground-900">「新番追更」今日更新 3 期新信息</p>
              <div className="mt-3 flex items-center gap-2">
                <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700">学习资料</span>
                <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700">实用工具</span>
              </div>
            </div>

            <div className="w-3/4 rounded-xl bg-background-50/95 p-5 shadow-sm ring-1 ring-background-200 animate-float-in" style={{ animationDelay: "0.15s" }}>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">最新合集</span>
                <i className="ri-folder-shield-2-line text-accent-500" aria-hidden="true" />
              </div>
              <p className="mt-2 text-sm font-semibold text-foreground-900">装机必备清单 · 已补 5 件便携工具</p>
            </div>

            <div className="ml-6 w-2/3 rounded-xl bg-background-50/95 p-5 shadow-sm ring-1 ring-background-200 animate-float-in" style={{ animationDelay: "0.25s" }}>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">社区热聊</span>
                <i className="ri-chat-3-line text-primary-400" aria-hidden="true" />
              </div>
              <p className="mt-2 text-sm font-semibold text-foreground-900">昨晚那部深夜番后劲太大？</p>
              <span className="mt-2 inline-block text-xs text-accent-600">312 人正聊</span>
            </div>
          </div>
        </div>
      </div>

      {/* 底部数据条 */}
      <div className="relative mx-auto w-full max-w-7xl px-4 pb-14 md:px-6 md:pb-16">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl bg-background-200 ring-1 ring-background-200 sm:grid-cols-4">
          {statItems.map((s) => (
            <div key={s.value} className="bg-background-50 px-5 py-5 text-center">
              <div className="font-brand text-3xl text-primary-600">{s.num}</div>
              <div className="mt-1 text-xs text-foreground-500">{s.value}</div>
              <div className="text-[11px] text-foreground-400">{s.unit}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}